<template>
  <div
    class="download-group"
  >
    <v-btn
      class="primary"
      @click="showPopup = !showPopup"
    >
      {{ $vuetify.lang.t('$vuetify.download') }}
    </v-btn>
    <div
      v-show="showPopup"
      class="download-group__popup"
    >
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  data: () => {
    return {
      showPopup: false,
    };
  },
  created() {
    document.addEventListener('click', (event) => {
      if (!event.target.closest('.download-group')) {
        this.showPopup = false;
      }
    }, false);
  },
};
</script>

<style lang="scss">
  .download-group{
    position: relative;
    .download-group__popup{
      position: absolute;
      width: 100%;
      form{
        width: 100%;
        .v-btn{
          width: 100%;
        }
      }
    }
  }
</style>
